import { AudioDeviceInfo, VideoDeviceInfo } from "@azure/communication-calling";
import { mergeStyles } from "@fluentui/react";
import React from "react";
import { useTheme, VideoStreamOptions } from "@azure/communication-react";
import { AudioAndVideoDeviceSettings } from "./AudioAndVideoDeviceSettings";
import { PcpSecondaryButton } from "../BaseComponents";
import { useBoolean } from "@fluentui/react-hooks";
import { Divider, makeStyles, tokens } from "@fluentui/react-components";
import { DismissFilled } from "@fluentui/react-icons";
import { SelectVideoEffectPane } from "../VideoEffects/SelectVideoEffectPane";


export interface LocalDeviceSettingsType {
    isMobile?: boolean;
    cameras: VideoDeviceInfo[];
    microphones: AudioDeviceInfo[];
    speakers: AudioDeviceInfo[];
    selectedCamera?: VideoDeviceInfo;
    selectedMicrophone?: AudioDeviceInfo;
    selectedSpeaker?: AudioDeviceInfo;
    microphonePermissionGranted: boolean | undefined;
    cameraPermissionGranted: boolean | undefined;
    onSelectCamera: (device: VideoDeviceInfo, options?: VideoStreamOptions) => Promise<void>;
    onSelectMicrophone: (device: AudioDeviceInfo) => Promise<void>;
    onSelectSpeaker: (device: AudioDeviceInfo) => Promise<void>;
    onClickEnableDevicePermission?: () => void;
}

const useStyles = makeStyles({
    expandButton: {
        maxHeight: 0,
        overflow: "hidden",
        // TODO: uncomment in order to create animation
        // transition: 'max-height 0.3s ease-out',

        '&.expanded': {
            maxHeight: '500px',
            overflow: 'visible',
        },
    },

    divider: {
        marginTop: '8px',
        marginBottom: '8px',
    },


    settingsExpandedContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: 'center',
        position: 'relative',
        padding: '18px',
    },
    settingsExpandedLabel: {
        width: "100%",
    },
    settingsExpandedIcon: {
        textAlign: "end",
        paddingRight: "10px",
        position: "absolute",
        right: "10px",
        top: "21px",
        color: tokens.colorBrandBackground,
    },
});


export const LocalDeviceSettings = (props: LocalDeviceSettingsType): JSX.Element => {
    const { isMobile } = props;
    const styles = useStyles();
    const theme = useTheme();

    const [settingsExpanded, { setTrue: expandSettings, setFalse: collapseSettings, toggle: toggleSettings }] = useBoolean(false);

    return (
        <>
            {!isMobile && (
                <>
                    <div className={mergeStyles({ marginBottom: '16px' })}>
                        <AudioAndVideoDeviceSettings
                            {...props}
                        />
                    </div>
                    <div>
                        <SelectVideoEffectPane />
                    </div>
                </>
            )}

            {isMobile && (
                <>
                    {settingsExpanded && (
                        <Divider appearance={'strong'} inset={true} className={mergeStyles(styles.divider)} />
                    )}

                    <ExpandableSettingsButton
                        isExpanded={settingsExpanded}
                        expand={expandSettings}
                        collapse={collapseSettings}
                        toggle={toggleSettings}
                    />

                    <div className={mergeStyles(styles.expandButton, settingsExpanded ? 'expanded' : '' )}>
                        <div className={mergeStyles({ marginBottom: '16px' })}>
                            <AudioAndVideoDeviceSettings
                                {...props}
                                renderTitle={<></>}
                            />
                        </div>
                        <Divider appearance={'strong'} inset={true} className={mergeStyles(styles.divider)} />
                        <div className={mergeStyles({ marginBottom: '33px', marginTop: '20px' })}>
                            <SelectVideoEffectPane renderTitle={<></>} />
                        </div>
                    </div>

                </>
            )}
        </>
    );
};


const ExpandableSettingsButton = (props: {
    isExpanded?: boolean;
    expand: () => void;
    collapse: () => void;
    toggle: () => void;
}): JSX.Element => {
    const styles = useStyles();

    return (
        <>
            {props.isExpanded && (
                <div onClick={props.collapse} className={mergeStyles(styles.settingsExpandedContainer)}>
                    <div className={mergeStyles(styles.settingsExpandedLabel)}>
                        Einstellungen
                    </div>
                    <div className={mergeStyles(styles.settingsExpandedIcon)}>
                        <DismissFilled />
                    </div>
                </div>
            )}

            {!props.isExpanded && (
                <PcpSecondaryButton onClick={props.toggle} style={{ marginBottom: '18px' }}>Einstellungen</PcpSecondaryButton>
            )}
        </>
    );
}
